import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-bold.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')